import { Redirect, Route, Switch } from 'react-router-dom'

import Profile from '../../pages/Profile'
import NotFound from '../../pages/NotFound'
import { TRoutes } from '../../shared/const'
import Dashboard from '../../pages/Dashboard'
import CreateSchool from '../../pages/CreateSchool'
import CompanyProfile from '../../pages/CompanyProfile'
import CompanyReview from '../../pages/CompanyReview'
import CompanyEmployee from '../../pages/CompanyEmployee'
import InvoicesPage from '../../pages/AdminPages/Invoice'
import UsersPage from '../../pages/AdminPages/Users'
import AdminsPage from '../../pages/AdminPages/Admins'
import SchoolsPage from '../../pages/AdminPages/Schools'
import CompaniesPage from '../../pages/AdminPages/Companies'
import EmailTemplatesPage from '../../pages/AdminPages/EmailTemplates'
import NewEmailTemplatePage from '../../pages/AdminPages/NewEmailTemplate'
import CompanyExperts from '../../components/views/student/CompanyExperts'

import CompaniesList from '../../pages/CompaniesList'
import TeacherCompanyPage from '../../pages/TeacherCompany'
import {
	AdminMiniCompaniesPage,
	AdminMiniCompanyPage,
	TeacherMiniCompaniesPage,
	TeacherMiniCompanyPage
} from '../../pages/MiniCompanies'
import StudentsList from '../../pages/StudentsList'
import DocumentsList from '../../pages/DocumentsList'
import Shares from '../../pages/Shares'
import News from '../../pages/News'
import Reports from '../../pages/Reports'
import ReportsTable from '../../pages/ReportsTable'
import UpdateSchools from '../../pages/UpdateSchools'
import NotificationPage from '../../pages/Notification'
import MyRequestsPage from '../../pages/MyRequests'

import ConfirmEmailChange from '../../components/views/teacher/Profile/components/ConfirmEmailChange'
import StudentEmailConfirm from '../../components/views/student/ConfirmEmailChange'
import AdminEmailConfirm from '../../components/views/admin/Profile/components/ConfirmEmailChange'
import ExpertsPage from '../../pages/AdminPages/Experts'
import SupportersPage from '../../pages/Supporters'
import SupporterProfilePage from '../../pages/SupporterProfile'
import SupporterConnectionsPage from '../../pages/SupporterConnections'
import SupportRequestsPage from '../../pages/SupportRequests'
import HandbookPage from '../../pages/Handbook'
import TrainingPage from '../../pages/Training'
import PresentationsPage from '../../pages/Presentations'
import CommunicationPage from '../../pages/Communication'
import TicketsPage from '../../pages/Tickets'
import ConceptPage from '../../pages/Concept'
import ConceptReportPage from '../../pages/ConceptReport'
import ChangelogPage from '../../pages/Changelog'
import AnnualReportPage from '../../pages/AnnualReport'
import Settings from '../../pages/Settings'
import EditCompany from '../../pages/AdminPages/EditCompany'
import DocumentsPage from '../../pages/AdminPages/Documents'
import ReportReview from '../../pages/AdminPages/ReportReview'
import CompanyMessagesPage from '../../pages/CompanyMessages'
import { CoursesPage, CoursePage, CourseLessonPage, CourseQuizPage } from '../../pages/Courses'
import { TlCoursesPage, TlCoursePage } from '../../pages/TlCourses'
import { AdminCoursesPage, AdminCourseEditorPage } from '../../pages/CoursesAdmin'
import CourseReportPage from '../../pages/CourseReport'

function Main() {
	return (
		<Switch>
			<Route path={TRoutes.DASHBOARD} exact component={Dashboard} />
			<Route path={TRoutes.COMPANY} exact component={CompanyProfile} />
			<Route path={TRoutes.COMPANY_REVIEW()} exact component={CompanyReview} />
			<Route path={TRoutes.COMPANY_MESSAGES()} exact component={CompanyMessagesPage} />
			<Route path={TRoutes.STUDENTS} exact component={StudentsList} />

			<Route path={TRoutes.SHARES} exact component={Shares} />

			<Route path={TRoutes.COMPANIES} exact component={CompaniesList} />
			{/* Eine betreute Junior Company: dasselbe Profil wie bei der
			    Verwaltung, nur lesend. Steht unter der Liste, aus der sie
			    geöffnet wird. */}
			<Route path={TRoutes.TEACHER_COMPANY()} exact component={TeacherCompanyPage} />
			{/* Junior Mini Company (Anforderung #92) */}
			<Route path={TRoutes.MINI_COMPANIES} exact component={TeacherMiniCompaniesPage} />
			<Route path={TRoutes.MINI_COMPANY()} exact component={TeacherMiniCompanyPage} />

			<Route path={TRoutes.DOCUMENTS} exact component={DocumentsList} />

			<Route path={TRoutes.PROFILE} exact component={Profile} />

			<Route path={TRoutes.CREATE_SCHOOL} exact>
				<CreateSchool />
			</Route>

			<Route path={TRoutes.UPDATE_SCHOOL()} exact>
				<UpdateSchools />
			</Route>

			<Route path={TRoutes.COMPANY} exact component={CompanyProfile} />
			{/* Die Markt- und Risikoanalyse ist ein Abschnitt des Unternehmensprofils
			    geworden. Die alte Adresse bleibt bestehen und leitet dorthin — sonst
			    liefen Lesezeichen und Verweise aus alten E-Mails ins Leere. */}
			<Redirect from={TRoutes.COMPANY_INSURANCE} exact to={TRoutes.COMPANY_TAB('market')} />
			<Route path={TRoutes.COMPANY_EMPLOYEE} exact component={CompanyEmployee} />
			<Route path={TRoutes.COMPANY_EXPERTS} exact component={CompanyExperts} />
			<Route path={TRoutes.UPDATE_COMPANY()} exact component={EditCompany} />

			<Route path={TRoutes.REPORTS} exact component={Reports} />
			<Route path={TRoutes.REPORTS_TABLE} exact component={ReportsTable} />
			<Route path={TRoutes.REPORT_REVIEW()} exact component={ReportReview} />
			<Route path={TRoutes.USERS} exact component={UsersPage} />
			<Route path={TRoutes.INVOICES} exact component={InvoicesPage} />
			<Route path={TRoutes.ADMINS} exact component={AdminsPage} />
			<Route path={TRoutes.SCHOOLS} exact component={SchoolsPage} />
			<Route path={TRoutes.ADMIN_COMPANIES} exact component={CompaniesPage} />
			<Route path={TRoutes.ADMIN_MINI_COMPANIES} exact component={AdminMiniCompaniesPage} />
			<Route path={TRoutes.ADMIN_MINI_COMPANY()} exact component={AdminMiniCompanyPage} />
			<Route path={TRoutes.ADMIN_DOCUMENTS} exact component={DocumentsPage} />
			<Route path={TRoutes.EMAILS} exact component={EmailTemplatesPage} />
			<Route path={TRoutes.NEW_EMAIL_TEMPLATE} exact component={NewEmailTemplatePage} />
			<Route path={TRoutes.NEWS} exact component={News} />
			<Route path={TRoutes.EXPERTS} exact component={ExpertsPage} />

			{/* Unterstuetzer:innen-Modul */}
			<Route path={TRoutes.SUPPORTERS} exact component={SupportersPage} />
			<Route path={TRoutes.SUPPORTER_PROFILE} exact component={SupporterProfilePage} />
			<Route path={TRoutes.SUPPORTER_CONNECTIONS} exact component={SupporterConnectionsPage} />
			<Route path={TRoutes.SUPPORT_REQUESTS} exact component={SupportRequestsPage} />
			<Route path={TRoutes.TRAINING} exact component={TrainingPage} />
			<Route path={[TRoutes.PRESENTATIONS, TRoutes.PRESENTATION()]} exact component={PresentationsPage} />
			<Route path={TRoutes.HANDBOOK} exact component={HandbookPage} />
			<Route path={TRoutes.COMMUNICATION} exact component={CommunicationPage} />
			<Route path={TRoutes.TICKETS} exact component={TicketsPage} />
			<Route path={TRoutes.CONCEPT} exact component={ConceptPage} />
			<Route path={TRoutes.CONCEPT_REPORT} exact component={ConceptReportPage} />
			{/* Kurse: Lektion und Quiz vor der Kursseite, sonst fängt `/kurse/:id` sie ab. */}
			{/* Kurse von TalentsLounge (Menüpunkt „Kurse") */}
			<Route path={TRoutes.TL_COURSES} exact component={TlCoursesPage} />
			<Route path={TRoutes.TL_COURSE()} exact component={TlCoursePage} />
			<Route path={TRoutes.COURSES} exact component={CoursesPage} />
			<Route path={TRoutes.COURSE_LESSON()} exact component={CourseLessonPage} />
			<Route path={TRoutes.COURSE_QUIZ()} exact component={CourseQuizPage} />
			<Route path={TRoutes.COURSE()} exact component={CoursePage} />
			<Route path={TRoutes.ADMIN_COURSES} exact component={AdminCoursesPage} />
			<Route path={TRoutes.ADMIN_COURSE()} exact component={AdminCourseEditorPage} />
			<Route path={TRoutes.COURSE_REPORT} exact component={CourseReportPage} />
			<Route path={TRoutes.CHANGELOG} exact component={ChangelogPage} />

			{/*
			 * Junior-Bilanz: absichtlich ohne Menueeintrag. Der Bericht wird mit
			 * Junior Achievement abgestimmt, bevor er jemandem angeboten wird —
			 * bis dahin kommt hin, wer die Adresse hat und Bundesadmin ist.
			 */}
			<Route path={TRoutes.ANNUAL_REPORT} exact component={AnnualReportPage} />

			<Route path={TRoutes.NOTIFICATIONS} exact component={NotificationPage} />
			{/*
			 * „Meine Anfragen" steht jeder angemeldeten Rolle offen — die
			 * Schnittstelle dahinter kennt ohnehin nur die eigenen Vorgänge.
			 */}
			<Route path={TRoutes.MY_REQUESTS} exact component={MyRequestsPage} />
			<Route path={TRoutes.SETTINGS} exact component={Settings} />

			<Route path={TRoutes.EMAIL_CHANGE_CONFIRM} exact component={ConfirmEmailChange} />
			<Route path={TRoutes.STUDENT_EMAIL_CHANGE_CONFIRM} exact component={StudentEmailConfirm} />
			<Route path={TRoutes.ADMIN_EMAIL_CHANGE_CONFIRM} exact component={AdminEmailConfirm} />
			<Route exact path={TRoutes.NOT_FOUND} component={NotFound} />
			<Redirect exact from="*" to={TRoutes.NOT_FOUND} />
		</Switch>
	)
}

export default Main
